<template>
  <el-row class="home" :gutter="20" justify="space-around">
    <el-col
      :span="8"
      :offset="2"
      :md="{ span: 8, offset: 2 }"
      :lg="{ span: 8, offset: 4 }"
    >
      <!-- <div class="welcome" v-html="text.text"></div> -->
      <div class="welcome">
        <h1>Seja bem-vindo ao <strong>jeito pixeon de ser e fazer</strong></h1>
        <h3 class="pt-3">
          Somos feitos de pessoas que se movem pelo propósito de
          <strong>inovar pela vida</strong>. Somos únicos, temos a nossa
          individualidade e <strong>vivemos a soma</strong>. Seguimos
          <strong>valores que nos fortalecem como time</strong>.
        </h3>
        <p class="pt-3">
          Temos a <strong>tecnologia pulsando em nossas veias</strong> e nossos
          corações batem no ritmo de nossos clientes.
        </p>
      </div>
    </el-col>
    <el-col :span="10">
      <div class="block">
        <img
          class="icon"
          alt="Vue logo"
          src="../../assets/images/home-icon.png"
        />
      </div>
    </el-col>
  </el-row>
</template>

<script>
import axios from 'axios'
import { ref } from 'vue'
import { firebaseRoutes } from '../../config/firebase.conf'
export default {
  name: 'Home',
  components: {},

  async setup () {
    const text = ref('')
    text.value = await axios.get(firebaseRoutes.homePage).then((response) => {
      const result = []
      for (const id in response.data) {
        result.push({
          id: id,
          text: response.data[id].text
        })
      }
      return result[0]
    })

    return {
      text
    }
  }
}
</script>

<style lang="scss" >
@import "~@/styles/variables.scss";
.home {
  justify-content: space-around;
  align-items: center;
  height: 100%;
}
.welcome {
  max-width: 40.5rem;
  h1,
  h3 {
    color: $purple;
  }
}
</style>

<style lang="scss" scoped>
.icon {
  max-height: 40rem;
}
</style>
